import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import image from './tux.png';
import Routes from '../../constants/routes';
import { setDocumentTitle } from '../../helpers/pageTitle';

const NotFoundPage = () => {
    // catch-all route has no fixed path for RouteTitle to match, so set it here
    useEffect(() => {
        setDocumentTitle('Page Not Found');
    }, []);

    return (
        <div className="container mt-5">
            <div className="row mt-5">
                <div className="col-sm-4">
                    <img className="img-fluid" src={image} alt="Not Found" />
                </div>
                <div className="col-sm-8 pb-2 align-self-center">
                    <span className='text-center'>
                        <h1>Oops!</h1>
                        <h5 className="pt-3">The page you are looking for was moved, renamed, removed, or maybe never existed. You&apos;ll want to update any bookmarks or favorites.</h5>
                        <h5 className="pt-3">Use the menu above or…</h5>
                        <p className="h6 mb-1">
                            <Link to={Routes.DashboardLocation}>Go to the Dashboard</Link>
                        </p>
                        <p className="h6">
                            <Link to={Routes.Tasks}>Go to the Task List</Link>
                        </p>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;